(function () {
  var MILES_PER_KM = 0.621371;

  function haversineDistanceKm(lat1, lon1, lat2, lon2) {
    function toRad(deg) {
      return (deg * Math.PI) / 180;
    }
    var R = 6371;
    var dLat = toRad(lat2 - lat1);
    var dLon = toRad(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
  }

  function StoreLocator(root) {
    this.root = root;
    this.unit = root.dataset.unit || 'mi';
    this.resultsLimit = parseInt(root.dataset.resultsLimit || '0', 10);
    this.listEl = root.querySelector('[data-locator-list]');
    this.input = root.querySelector('[data-locator-input]');
    this.searchBtn = root.querySelector('[data-locator-search]');
    this.geoBtn = root.querySelector('[data-locator-geo]');
    this.mapEl = root.querySelector('[data-locator-map]');
    this.statusEl = root.querySelector('[data-locator-status]');
    this.locations = this.parseLocations();
    this.map = null;

    this.initMap();
    this.renderList(this.locations, false);
    this.bindEvents();
  }

  StoreLocator.prototype.parseLocations = function () {
    var nodes = Array.prototype.slice.call(this.root.querySelectorAll('[data-locator-item]'));
    return nodes
      .map(function (el) {
        return {
          name: el.dataset.name,
          address1: el.dataset.address1,
          address2: el.dataset.address2,
          city: el.dataset.city,
          state: el.dataset.state,
          zip: el.dataset.zip,
          phone: el.dataset.phone,
          hours: el.dataset.hours,
          lat: parseFloat(el.dataset.lat),
          lng: parseFloat(el.dataset.lng),
          url: el.dataset.url,
          distance: null,
          marker: null
        };
      })
      .filter(function (loc) {
        return !isNaN(loc.lat) && !isNaN(loc.lng);
      });
  };

  StoreLocator.prototype.initMap = function () {
    if (typeof L === 'undefined' || !this.mapEl) return;

    this.map = L.map(this.mapEl, { scrollWheelZoom: false });
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; OpenStreetMap contributors',
      maxZoom: 19
    }).addTo(this.map);

    var self = this;
    this.locations.forEach(function (loc) {
      var marker = L.marker([loc.lat, loc.lng]).addTo(self.map);
      marker.bindPopup(
        '<strong>' + escapeHtml(loc.name) + '</strong><br>' +
        escapeHtml(loc.address1) + '<br>' +
        escapeHtml(loc.city) + ', ' + escapeHtml(loc.state) + ' ' + escapeHtml(loc.zip)
      );
      marker.on('click', function () {
        self.setActive(loc);
      });
      loc.marker = marker;
    });

    this.fitAll();
  };

  StoreLocator.prototype.fitAll = function () {
    if (!this.map || !this.locations.length) return;
    var markers = this.locations.map(function (l) { return l.marker; }).filter(Boolean);
    if (!markers.length) return;
    var group = L.featureGroup(markers);
    if (group.getBounds().isValid()) {
      this.map.fitBounds(group.getBounds().pad(0.2));
    }
  };

  StoreLocator.prototype.bindEvents = function () {
    var self = this;
    if (this.searchBtn) {
      this.searchBtn.addEventListener('click', function () {
        self.handleSearch();
      });
    }
    if (this.input) {
      this.input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          self.handleSearch();
        }
      });
    }
    if (this.geoBtn) {
      this.geoBtn.addEventListener('click', function () {
        self.handleGeolocate();
      });
    }
  };

  StoreLocator.prototype.setStatus = function (msg, isError) {
    if (!this.statusEl) return;
    this.statusEl.textContent = msg || '';
    this.statusEl.classList.toggle('is-error', !!isError);
  };

  StoreLocator.prototype.handleSearch = function () {
    var self = this;
    var query = (this.input.value || '').trim();
    if (!query) {
      this.setStatus('Please enter an address, city, or ZIP code.', true);
      return;
    }
    this.setStatus('Searching…');
    this.geocode(query)
      .then(function (coords) {
        self.sortAndRender(coords.lat, coords.lng);
        self.setStatus('');
      })
      .catch(function (err) {
        self.setStatus(err.message || "We couldn't find that location. Try a different search.", true);
      });
  };

  StoreLocator.prototype.handleGeolocate = function () {
    var self = this;
    if (!navigator.geolocation) {
      this.setStatus('Geolocation is not supported by your browser.', true);
      return;
    }
    this.setStatus('Finding your location…');
    navigator.geolocation.getCurrentPosition(
      function (pos) {
        self.setStatus('');
        self.sortAndRender(pos.coords.latitude, pos.coords.longitude);
      },
      function () {
        self.setStatus("We couldn't access your location. Please allow location access or search by address.", true);
      }
    );
  };

  StoreLocator.prototype.geocode = function (query) {
    var url = 'https://nominatim.openstreetmap.org/search?format=json&limit=1&q=' + encodeURIComponent(query);
    return fetch(url, { headers: { Accept: 'application/json' } })
      .then(function (res) {
        if (!res.ok) throw new Error('Search failed. Please try again.');
        return res.json();
      })
      .then(function (data) {
        if (!data.length) throw new Error('No results for that address. Try a city, state, or ZIP code.');
        return { lat: parseFloat(data[0].lat), lng: parseFloat(data[0].lon) };
      });
  };

  StoreLocator.prototype.sortAndRender = function (lat, lng) {
    var self = this;
    this.locations.forEach(function (loc) {
      var km = haversineDistanceKm(lat, lng, loc.lat, loc.lng);
      loc.distance = self.unit === 'km' ? km : km * MILES_PER_KM;
    });
    var sorted = this.locations.slice().sort(function (a, b) {
      return a.distance - b.distance;
    });
    var display = this.resultsLimit > 0 ? sorted.slice(0, this.resultsLimit) : sorted;
    this.renderList(display, true);

    if (this.map && sorted[0]) {
      this.map.setView([sorted[0].lat, sorted[0].lng], 11);
      if (sorted[0].marker) sorted[0].marker.openPopup();
      this.setActive(sorted[0]);
    }
  };

  StoreLocator.prototype.renderList = function (locations, showDistance) {
    if (!this.listEl) return;
    this.listEl.innerHTML = '';

    if (!locations.length) {
      this.listEl.innerHTML = '<div class="store-locator__empty">No locations found.</div>';
      return;
    }

    var self = this;
    locations.forEach(function (loc, idx) {
      var item = document.createElement('div');
      item.className = 'store-locator__item';
      item.dataset.lat = loc.lat;
      item.dataset.lng = loc.lng;

      var distanceHtml = '';
      if (showDistance && loc.distance != null) {
        distanceHtml =
          '<span class="store-locator__item-distance">' + loc.distance.toFixed(1) + ' ' + self.unit + '</span>' +
          (idx === 0 ? '<span class="store-locator__badge-nearest">Nearest</span>' : '');
      }

      item.innerHTML =
        '<div class="store-locator__item-name">' + escapeHtml(loc.name) + distanceHtml + '</div>' +
        '<div class="store-locator__item-address">' +
        escapeHtml(loc.address1) + (loc.address2 ? ', ' + escapeHtml(loc.address2) : '') + '<br>' +
        escapeHtml(loc.city) + ', ' + escapeHtml(loc.state) + ' ' + escapeHtml(loc.zip) +
        '</div>' +
        (loc.phone ? '<div class="store-locator__item-phone">' + escapeHtml(loc.phone) + '</div>' : '') +
        (loc.hours ? '<div class="store-locator__item-hours">' + escapeHtml(loc.hours) + '</div>' : '') +
        '<div class="store-locator__item-actions">' +
        '<a href="https://www.google.com/maps/dir/?api=1&destination=' + loc.lat + ',' + loc.lng + '" target="_blank" rel="noopener">Get Directions</a>' +
        (loc.url ? '<a href="' + loc.url + '">Store Details</a>' : '') +
        '</div>';

      item.addEventListener('click', function () {
        if (self.map) self.map.setView([loc.lat, loc.lng], 13);
        if (loc.marker) loc.marker.openPopup();
        self.setActive(loc);
      });

      self.listEl.appendChild(item);
    });
  };

  StoreLocator.prototype.setActive = function (loc) {
    var items = this.listEl.querySelectorAll('.store-locator__item');
    items.forEach(function (el) {
      el.classList.remove('is-active');
    });
    var match = Array.prototype.find.call(items, function (el) {
      return parseFloat(el.dataset.lat) === loc.lat && parseFloat(el.dataset.lng) === loc.lng;
    });
    if (match) {
      match.classList.add('is-active');
      match.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  };

  function escapeHtml(str) {
    if (str == null) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  document.addEventListener('DOMContentLoaded', function () {
    var roots = document.querySelectorAll('[data-store-locator]');
    roots.forEach(function (root) {
      new StoreLocator(root);
    });
  });
})();
